<template>
  <v-card class="rounded-card pt-3 px-0 pb-0" height="100%">
    <v-card-title class="pt-0 pb-0">
      <v-row>
        <v-col cols="12" class="text-center">
          <v-btn
            fab
            right
            absolute
            width="30"
            height="30"
            class="close-button"
            color="blue"
            @click="close"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <h2
            class="primary--text font-weight-black"
            :class="{
              'text-h6 font-weight-bold text-center': $vuetify.breakpoint.mdAndDown
            }"
          >
            CENTRO DE AYUDA
          </h2>
        </v-col>
        <v-col cols="12" md="12" lg="4" class="py-0 my-0">
          <v-text-field
            dense
            rounded
            outlined
            :class="{'ml-10': $vuetify.breakpoint.mdAndUp}"
            label="Buscador"
            v-model="search"
          />
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-text style="height: 60vh;">
      <v-expansion-panels
          accordion
          popout
          focusable
          flat
          hover
          id="panel"
          v-model="panel"
        >
          <v-expansion-panel v-for="(item, index) in faqFiltered" :key="index">
            <v-expansion-panel-header class="primary--text py-0">
              <v-row no-gutters class="py-0" align="center">
                <h4>{{ index + 1 }}.- {{ item.question }}</h4>
              </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="px-auto">
              <Media
                class="video-md"
                :class="{'video-md': $vuetify.breakpoint.mdAndUp, 'video-sm': $vuetify.breakpoint.smAndDown}"
                :muted="(true)"
                :kind="'video'"
                :controls="true"
                :autoplay="false"
                :src="[item.video]"
                poster="https://swatlab-financiera.s3.us-east-2.amazonaws.com/websites/ioc/faq/cover.png"
              >
              </Media>
            </v-expansion-panel-content>
          </v-expansion-panel>
      </v-expansion-panels>
    </v-card-text>
    <v-card-text class="text-center pt-3">
      <v-btn rounded color="primary" @click="close()">Cerrar</v-btn>
    </v-card-text>
  </v-card>

</template>
<script>

import Media from '@dongido/vue-viaudio'

export default {
  name: 'Help',
  components: { Media },
  props: {
    dialog: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      panel: [0],
      search: null,
      faq: [
        {
          question: '¿Cuánto crédito disponible tengo para vender facturas?',
          video: 'https://swatlab-financiera.s3.us-east-2.amazonaws.com/websites/ioc/faq/dashboard/available-credit.mp4',
          videoTitle: 'Crédito Disponible',
          keywords: ['factura', 'credito', 'crédito', 'disponible', 'venta', 'vender', 'linea']
        },
        {
          question: '¿Cómo subo mis facturas?',
          video: 'https://swatlab-financiera.s3.us-east-2.amazonaws.com/websites/ioc/faq/dashboard/upload-invoices.mp4',
          videoTitle: 'Subir o cargar facturas',
          keywords: ['factura', 'carga', 'cargar', 'subir']
        },
        {
          question: '¿Cómo vendo mis facturas?',
          video: 'https://swatlab-financiera.s3.us-east-2.amazonaws.com/websites/ioc/faq/dashboard/sale-invoices2.mp4',
          videoTitle: 'Venta de facturas',
          keywords: ['vender', 'venta', 'factura']
        },
        {
          question: '¿Cómo eliminar una factura que no quiero vender?',
          video: 'https://swatlab-financiera.s3.us-east-2.amazonaws.com/websites/ioc/faq/dashboard/delete-restore-invoices.mp4',
          videoTitle: 'Elminar facturas',
          keywords: ['eliminar', 'factura', 'borrar']
        },
        {
          question: '¿Dónde veo mis facturas en crédito?',
          video: 'https://swatlab-financiera.s3.us-east-2.amazonaws.com/websites/ioc/faq/dashboard/credit-invoices.mp4',
          videoTitle: 'Facturas en crédito',
          keywords: ['veo', 'ver', 'visualizar', 'factura', 'consultar', 'credito', 'crédito']
        },
        {
          question: '¿Cómo veo las facturas que están en validación?',
          video: 'https://swatlab-financiera.s3.us-east-2.amazonaws.com/websites/ioc/faq/dashboard/validation-invoices.mp4',
          videoTitle: 'Facturas en validación',
          keywords: ['validacion', 'validación', 'factura']
        },
        {
          question: '¿Cómo veo las facturas que fueron rechazadas?',
          video: 'https://swatlab-financiera.s3.us-east-2.amazonaws.com/websites/ioc/faq/dashboard/rejected-invoices.mp4',
          videoTitle: 'Facturas rechazadas',
          keywords: ['rechazadas', 'factura', 'fallidas', 'consulta']
        },
        {
          question: '¿Cómo veo las facturas que están próximas a vencer?',
          video: 'https://swatlab-financiera.s3.us-east-2.amazonaws.com/websites/ioc/faq/dashboard/next-payments.mp4',
          videoTitle: 'Facturas a vencer',
          keywords: ['vencimiento', 'proximas', 'próximas', 'vencer', 'factura']
        },
        {
          question: '¿Cómo agrego y/o elimino usuarios?',
          video: 'https://swatlab-financiera.s3.us-east-2.amazonaws.com/websites/ioc/faq/profile/add-remove-users.mp4',
          videoTitle: 'Administración de usuarios',
          keywords: ['eliminar', 'eliminación', 'borrar', 'quitar', 'usuario', 'agreagr', 'añadir', 'notificacion']
        },
        {
          question: '¿Cómo cambio mi contraseña?',
          video: 'https://swatlab-financiera.s3.us-east-2.amazonaws.com/websites/ioc/faq/profile/change-pass.mp4',
          videoTitle: 'Cambio de contraseña',
          keywords: ['cambiar', 'contraseña', 'seguridad', 'sesion']
        },
        {
          question: '¿Cómo configuro las notificaciones?',
          video: 'https://swatlab-financiera.s3.us-east-2.amazonaws.com/websites/ioc/faq/profile/notifications.mp4',
          videoTitle: 'notifications',
          keywords: ['configurar', 'configuración', 'alertas', 'notificacion', 'quitar', 'activar', 'desactivar']
        },
        {
          question: '¿Qué son las referencias de pago y cómo se generan?',
          video: 'https://swatlab-financiera.s3.us-east-2.amazonaws.com/websites/ioc/faq/references/create-references.mp4',
          videoTitle: 'Generar referencias de Pago',
          keywords: ['referencias', 'pagos', 'generar', 'generación']
        },
        {
          question: '¿Cómo puedo consultar las referencias de pago que ya generé?',
          video: 'https://swatlab-financiera.s3.us-east-2.amazonaws.com/websites/ioc/faq/references/references.mp4',
          videoTitle: 'Consultar referencias de pago',
          keywords: ['consultar', 'referencias', 'pago', 'ver', 'visualizar', 'buscar', 'generadas']
        },
        {
          question: '¿Cómo veo las facturas que se han generado por intereses?',
          video: 'https://swatlab-financiera.s3.us-east-2.amazonaws.com/websites/ioc/faq/invoices/invoices.mp4',
          videoTitle: 'Facturas de intereses',
          keywords: ['intereses', 'factura', 'ver', 'veo', 'consultar', 'consulto', 'generadas']
        },
        {
          question: '¿Cómo veo las facturas que ya pagué/liquidé?',
          video: 'https://swatlab-financiera.s3.us-east-2.amazonaws.com/websites/ioc/faq/paidInvoices/paid-invoices.mp4',
          videoTitle: 'Facturas liquidadas',
          keywords: ['liquidadas', 'liquidé', 'pagadas', 'pagué', 'factura', 'consultar', 'consulto', 'ver', 'veo']
        },
        {
          question: '¿Cómo agrego y administro a mis clientes?',
          video: 'https://swatlab-financiera.s3.us-east-2.amazonaws.com/websites/ioc/faq/costcenter/administration.mp4',
          videoTitle: 'Agregar clientes',
          keywords: ['clientes', 'agregar', 'añadir', 'mis', 'administrar', 'pago', 'automático']
        },
        {
          question: '¿Cómo verifico si alguno de mis clientes tiene activado el pago automático?',
          video: 'https://swatlab-financiera.s3.us-east-2.amazonaws.com/websites/ioc/faq/costcenter/verify-status.mp4',
          videoTitle: 'Consultar status de pago automático',
          keywords: ['clientes', 'ver', 'consultar', 'mis', 'verificar', 'pago', 'automático', 'status']
        },
        {
          question: '¿Cómo consulto los movimientos de pago automático de mis clientes?',
          video: 'https://swatlab-financiera.s3.us-east-2.amazonaws.com/websites/ioc/faq/costcenter/balance.mp4',
          videoTitle: 'Consultar movimientos de pago automático',
          keywords: ['clientes', 'ver', 'consultar', 'consulto', 'mis', 'pago', 'automático', 'movimientos', 'pagos', 'pago']
        }
      ],
      faqSat: [
        {
          question: '¿Cómo habilito la sincronización con el SAT?',
          video: 'https://swatlab-financiera.s3.us-east-2.amazonaws.com/websites/ioc/faq/sat/sync-sat.mp4',
          videoTitle: 'Sincronizar con el SAT',
          keywords: ['sat', 'sincronizar', 'factura']
        },
        {
          question: '¿Cómo desactivo la sincronización con el SAT?',
          video: 'https://swatlab-financiera.s3.us-east-2.amazonaws.com/websites/ioc/faq/sat/unsync-sat.mp4',
          videoTitle: 'Desactivar sincronización con el SAT',
          keywords: ['sat', 'desincronizar', 'factura', 'desactivar']
        }
      ]
    }
  },

  async mounted () {
    document.addEventListener('keydown', (e) => {
      if (e.keyCode === 27) {
        this.close()
      }
    })
  },

  methods: {
    close () {
      this.panel = [0]
      this.$emit('update:dialog', false)
    }
  },

  computed: {
    faqData () {
      if (this.$store.getters.user.syncAllowed) {
        return this.faqSat.concat(this.faq)
      }
      return this.faq
    },
    faqFiltered () {
      if (this.search) {
        return this.faqData.filter(
          item => item.keywords.filter(
            item => item.toLowerCase().indexOf(this.search.toLowerCase()) > -1
          ).length > 0
        )
      }
      return this.faqData
    }
  },

  watch: {
    dialog (val) {
      !val && this.close()
    }
  }

}
</script>

<style>
  .video-sm {
    width: 100%;
  }

  .video-md {
    width: 65%;
    margin-right: 18%!important;
    margin-left: 18% !important;
  }
</style>
